<script lang="ts">
	import { env } from "$lib/env.client";
	import { onMount } from "svelte";
	import type { ClientUser } from "../../../models/ClientTypes";

	export let user: ClientUser;

	const email = user?.email;

	onMount(() => {
		!(function (e) {
			if (!window.pintrk) {
				window.pintrk = function () {
					window.pintrk.queue.push(Array.prototype.slice.call(arguments));
				};
				var n = window.pintrk;
				(n.queue = []), (n.version = "3.0");
				var t = document.createElement("script");
				(t.async = !0), (t.src = e);
				var r = document.getElementsByTagName("script")[0];
				r.parentNode.insertBefore(t, r);
			}
		})("https://s.pinimg.com/ct/core.js");

		pintrk("load", env.PUBLIC_PINTEREST_PIXEL_ID, email ? { em: email } : {});
		pintrk("page");
	});
</script>
